/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import * as default_data from '../config.js'

function PrivacyPage() {
  return (
    <div className="reg-page-mode">
    <Container>
    <Row className="justify-content-center reg-page-mode-header">
        <Col xs="12" md="12" lg="12" className="d-flex align-items-center">
          <a href="/" className="d-flex align-items-center">
            <img src="/logo.png" alt="Ask Sage" className="logo" />
          </a>
          <h1 className="user-list-h1">
            Privacy Policy
          </h1>
        </Col>
      </Row>
      <Row className="justify-content-center reg-page-mode-content">
        <Col xs="12" md="8" lg="8">
          Ask Sage Privacy Policy<br />
          <br />
Last Updated: January 28, 2024<br />
<br />
At Ask Sage, Inc., we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines the types of personal information we collect, how we process it, who has access to it, and the measures we take to keep it safe.<br />
<br />
1. Information We Collect<br />
<br />
When you use Ask Sage, we collect the following personal information:<br />
<br />
- Email address<br />
- First name<br />
- Last name<br />
- Organization<br />
- Country<br />
- IP address<br />
- Phone number<br />
<br />
Additionally, users can ingest their data into Ask Sage to train our GPT platform on their content. Users are responsible for creating datasets and assigning data to those datasets as needed.<br />
<br />
2. Google Login and Access to Files<br />
<br />
If you choose to log in using Google, we will have access to your basic profile information and any files that you explicitly allow us to access. We will use this information and access solely to provide our services to you. Your data will be stored in our vector database to enable you to use it against Ask Sage chatbot. That data will be only accessible by you and users you grant access to. It isn't used by our company for our models training or shared with third parties. The way we access, use, store, or share Google user data is limited to what is described in this privacy policy.<br />
<br />
3. How We Process Your Information<br />
<br />
We process your personal information for the following purposes:<br />
<br />
- User management: To create and manage your Ask Sage account, provide access to our services, and communicate with you about your account and our services.<br />
- Logging: To maintain a record of your activities on our platform, monitor usage, and improve our services.<br />
- Security: To protect the integrity of our platform, detect and prevent unauthorized access, and ensure the safety of your personal information.<br />
- Providing GPT platform services: To offer our GPT platform services and ensure that data is kept secure for each account, using data-centric security with zero trust baked in.<br />
<br />
4. Who Has Access to Your Information<br />
<br />
Access to your personal information is limited to:<br />
<br />
- Ask Sage employees and administrators: Our team members who need access to your information to provide support, manage your account, and maintain the security of our platform.<br />
- Authorized third-party service providers: We may share your information with trusted third-party service providers who assist us in providing our services, such as Azure Government for hosting and data storage. These providers are required to maintain the confidentiality and security of your information and are not permitted to use it for any other purpose.<br />
<br />
5. How We Keep Your Information Safe<br />
<br />
We take the security of your personal information very seriously and have implemented the following measures to protect it:<br />
<br />
- Hosting on Azure Government: Our platform is hosted on Azure Government at IL5, ensuring the highest level of data safety and security.<br />
- Access control: We enforce strict access controls, including the use of CAC authentication for access to Controlled Unclassified Information (CUI) datasets and MFA using OTP with Microsoft Authenticator for administrative access.<br />
- Data encryption: All data is encrypted in transit using TLS 1.3 tunnels and at rest using Azure Government's encryption capabilities.<br />
- Continuous monitoring: We leverage Azure Firewall v2, Microsoft Defender for Cloud, and other security solutions to continuously monitor our network and detect unauthorized access or attacks.<br />
<br />
6. Your Rights and Choices<br />
<br />
You have the right to access, correct, or delete your personal information held by Ask Sage. To exercise these rights, please contact us at {default_data.default_support_email}.<br />
<br />
7. Changes to This Privacy Policy<br />
<br />
We may update this Privacy Policy from time to time to reflect changes in our practices or applicable laws. We will notify you of any material changes by posting the updated policy on our website and updating the "Last Updated" date at the top of this policy.<br />
<br />
8. Contact Us
<br />
If you have any questions or concerns about this Privacy Policy or our privacy practices, please contact us at {default_data.default_support_email}.<br /><br />
          </Col>
      </Row>
      <Row className="justify-content-center reg-page-mode-footer">
        <Col xs="12" md="12" lg="12">
        Copyright &copy; {default_data.default_copywrite_year} Ask Sage, Inc.
        </Col>
      </Row>
      </Container>  
      </div>    
  );
}

export default PrivacyPage;
